<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <app-sidebar></app-sidebar>
    <div class="layout-page">
      <app-navbar></app-navbar>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

<app-tour-overlay />
